import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  regexPatterns,
  maxLengths,
} from "../shared/utilities/validators.utility";
import { ApiService } from "../shared/services/api.service";

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
})
export class ContactUsComponent implements OnInit {
  contactUsForm: FormGroup;
  isSubmitted = false;
  isSending = false;
  emailSent = false;
  reasonsList = [
    {
      labelKey: "digital_experience",
      value: "Digital Experience"
    },
    {
      labelKey: "paper_experience",
      value: "Paper Experience"
    },
    {
      labelKey: "my_ci",
      value: "MyCI"
    },
    {
      labelKey: "general",
      value: "General"
    }
  ];
  subjectsList = [
    {
      labelKey: "classroom_setup",
      value: "Classroom Setup / Mgmt."
    },
    {
      labelKey: "login_issue",
      value: "Log-in issue"
    },
    {
      labelKey: "school_support",
      value: "School / Org Support"
    },
    {
      labelKey: "technical",
      value: "Technical / Error"
    },
    {
      labelKey: "suggestion",
      value: "Suggestion"
    },
  ];

  messageCharCount = 0;
  readonly maxFullNameLength = maxLengths.fullName;
  readonly maxEmailLength = maxLengths.email;
  readonly maxMessageLength = maxLengths.message;

  constructor(
    private readonly fb: FormBuilder,
    private readonly toast: ToastrService,
    private readonly _apiService: ApiService
  ) {}

  ngOnInit() {
    this.initForm();

    this.contactUsForm
      .get("message")
      .valueChanges.subscribe((value: string) => {
        this.messageCharCount = value.length;
      });
  }

  initForm() {
    this.contactUsForm = this.fb.group({
      firstName: ["", Validators.compose([
        Validators.required,
        Validators.pattern(regexPatterns.name)
      ])],
      lastName: ["", Validators.compose([
        Validators.required,
        Validators.pattern(regexPatterns.name)
      ])],
      email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(regexPatterns.email),
        ]),
      ],
      reason: ["", Validators.compose([Validators.required])],
      subject: ["", Validators.compose([Validators.required])],
      message: [
        "",
        Validators.compose([
          Validators.required,
          Validators.maxLength(this.maxMessageLength),
          Validators.pattern(regexPatterns.contactMessage)
        ]),
      ],
      captchaResponse: [null, Validators.required],
    });
  }

  public showToastrMsg(header: string, description: string, type: string) {
    return this.toast.show(description, header, { toastClass: type });
  }

  onSubmit() {
    this.isSubmitted = this.contactUsForm.invalid;
    if (!this.contactUsForm.invalid) {
      this.isSending = true;
      const submitContactUsRequest = {
        firstName: this.contactUsForm.get("firstName").value,
        lastName: this.contactUsForm.get("lastName").value,
        email: this.contactUsForm.get("email").value,
        reason: this.contactUsForm.get("reason").value,
        subject: this.contactUsForm.get("subject").value,
        body: this.contactUsForm.get("message").value,
        captchaResponse: this.contactUsForm.get("captchaResponse").value,
      };
      this._apiService.submitContactUs(submitContactUsRequest).subscribe({
        next: response => {
            if (response.error || response.code) {
                this.showToastrMsg(
                  "Request Failed",
                  "Please try again later. If the issue persists, please contact us at support@myclassroomeconomy.org",
                  "error"
                );
                this.isSending = false;
            } else {
                this.emailSent = true;
                this.isSending = false;
            }
        },
        error: () => {
          this.showToastrMsg(
            "Request Failed",
            "Please try again later. If the issue persists, please contact us at support@myclassroomeconomy.org",
            "error"
          );
            this.isSending = false;
        }
      });
    }
  }
}
